import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { INPUT, Field, Tick } from "./obUi";
import { CopyLink } from "./CopyLink";

export const NewOnboardingDialog = ({ open, onOpenChange, onCreated, onFillIn }) => {
  const [f, setF] = useState({ price_per_lead: "", firm_name: "", contact_email: "", email_link: false });
  const [made, setMade] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const close = (v) => { if (!v) { setMade(null); setF({ price_per_lead: "", firm_name: "", contact_email: "", email_link: false }); } onOpenChange(v); };
  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/onboardings", { ...f, price_per_lead: Number(f.price_per_lead) });
      setMade(data);
      onCreated();
      if (f.email_link) toast[data.emailed ? "success" : "warning"](data.emailed ? "Setup link emailed" : "Couldn't email the link — copy it and send it yourself");
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Couldn't create the link"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-lg border-2 border-black rounded-none" data-testid="new-onboarding-dialog">
        <DialogHeader>
          <DialogTitle className="font-chivo font-black uppercase tracking-tight">New buyer setup link</DialogTitle>
          <DialogDescription>Set the price first. The buyer fills in the rest by the private link, or you fill it in for them.</DialogDescription>
        </DialogHeader>
        {made ? <Made made={made} onFillIn={onFillIn} /> : (
          <div className="space-y-4">
            <Field label="Price per lead ($)" required>
              <input type="number" min={1} step="0.01" className={INPUT} value={f.price_per_lead} onChange={(e) => set("price_per_lead", e.target.value)} data-testid="new-ob-price" />
            </Field>
            <Field label="Firm name (optional)"><input className={INPUT} value={f.firm_name} onChange={(e) => set("firm_name", e.target.value)} data-testid="new-ob-firm" /></Field>
            <Field label="Contact email (optional)"><input type="email" className={INPUT} value={f.contact_email} onChange={(e) => set("contact_email", e.target.value)} data-testid="new-ob-email" /></Field>
            <Tick checked={f.email_link} onChange={(v) => set("email_link", v)} testId="new-ob-email-link" ro={!f.contact_email}>Email the link to this contact now</Tick>
            <button type="button" onClick={create} disabled={busy || !(Number(f.price_per_lead) > 0)} data-testid="new-ob-create"
                    className="w-full bg-black text-white py-3 text-xs font-bold uppercase tracking-widest hover:bg-zinc-800 transition-colors duration-100 disabled:opacity-40">
              {busy ? "Creating…" : "Create setup link"}
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

const Made = ({ made, onFillIn }) => (
  <div className="space-y-4" data-testid="new-ob-made">
    <p className="text-sm">Send this private link to the buyer. No login needed. It works for {30} days.</p>
    <CopyLink path={made.link_path} testId="new-ob-link" />
    <button type="button" onClick={() => onFillIn(made.id)} data-testid="new-ob-fill-in"
            className="w-full border-2 border-black py-3 text-xs font-bold uppercase tracking-widest hover:bg-zinc-100 transition-colors duration-100">
      Fill it in for them instead
    </button>
  </div>
);
